export default __webpack_public_path__ + "static/media/ic_star_blue_filled.123b1abe.svg";